import React, { Component } from 'react';

class Apply extends Component {
	render() {
		return (
			<section className="assessment bg select__to__apply">
				<div className="container-fluid">
					<h1 className="assessment__heading">Select all that apply to you</h1>
					<div className="select__to__apply--fields">
						<div className="form-group">
							<input type="checkbox" id="sleep" />
			      			<label for="sleep">Lack of Sleep</label>
						</div>
						<div className="form-group">
							<input type="checkbox" id="intake" />
			      			<label for="intake">Lack of water intake</label>
						</div>
						<div className="form-group">
							<input type="checkbox" id="Stressed" />
			      			<label for="Stressed">Stressed</label>
						</div>
						<div className="form-group">
							<input type="checkbox" id="Pregnant" />
			      			<label for="Pregnant">Pregnant</label>
						</div>
						<div className="form-group">
							<input type="checkbox" id="exposure" />
			      			<label for="exposure">High AC exposure</label>
						</div>
						<div className="form-group">
							<input type="checkbox" id="skin" />
			      			<label for="skin">Senstitive skin</label>
						</div>
						<div className="clearfix"></div>
					</div>
				</div>
			</section>
		);
	}
}


export default Apply;